import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import api from "../../api/api";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useTranslation } from "react-i18next";

const EditProfile = ({ onUpdateSuccess }) => {
  const { t } = useTranslation();
  const { user, updateUser } = useAuth();
  const [formData, setFormData] = useState({
    first_name: user?.first_name || "",
    last_name: user?.last_name || "",
    email: user?.email || "",
    phone_number: user?.phone_number || "",
  });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, phone_number: value === "" ? null : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await api.put(`/user/profile`, formData);
      setMessage(response.data.message);

      // ✅ Use the new updateUser function to sync state and local storage
      updateUser(response.data.user);

      // Call the parent's function to change the tab
      if (onUpdateSuccess) {
        onUpdateSuccess();
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      setMessage(error.response?.data?.message || t("profile.edit.error"));
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return (
      <div className="text-center mt-10 p-6 rounded-lg shadow-md bg-red-100 text-red-700">
        {t("profile.authRequiredEdit")}
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 sm:p-6 lg:p-8">
      <h1 className="text-4xl font-bold text-gray-800 mb-8 text-center">
        {t("profile.edit.title")}
      </h1>
      <div className="bg-white p-6 rounded-lg shadow-md mb-8 border border-gray-200">
        <form onSubmit={handleSubmit}>
          {message && (
            <p
              className={`mb-4 text-center ${
                message.includes("success") ? "text-green-500" : "text-red-500"
              }`}
            >
              {message}
            </p>
          )}

          <div className="mb-4">
            <label className="block text-gray-700">
              {t("profile.fields.firstName")}
            </label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">
              {t("profile.fields.lastName")}
            </label>
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">
              {t("profile.fields.email")}
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">
              {t("profile.fields.phoneNumber")}
            </label>
            <PhoneInput
              country={"us"}
              value={formData.phone_number}
              onChange={handlePhoneChange}
              inputProps={{
                name: "phone_number",
                required: false,
              }}
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-500 text-white font-bold py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none"
            disabled={loading}
          >
            {loading ? t("profile.edit.updating") : t("profile.edit.submit")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditProfile;
